var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 26.177 18.028 0 0 26.177h25.118l-7.088-9.99-3.517 5.191h-3.74l7.26-10.438 10.493 15.237H36Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.002 23.09c0-5.524-4.477-10-10-10s-10 4.476-10 10c0 5.522 4.477 10 10 10s10-4.478 10-10Z",
    fill: "#3E4062"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.002 14.34a8.75 8.75 0 1 0 0 17.498 8.75 8.75 0 0 0 0-17.499m0-1.25a10 10 0 1 1 0 20 10 10 0 0 1 0-20Z",
    fill: "#1E1F37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m29.553 22.54.967-1.642 2.607 4.061v.78-5.36a.4.4 0 0 0-.186-.322l-4.7-2.7a.414.414 0 0 0-.359 0l-.042.024-.016.01-4.556 2.641-.018.007a.415.415 0 0 0-.185.17.4.4 0 0 0-.051.17l.008 4.374 2.429-3.765a1.78 1.78 0 0 1 1.59-.65l.726.018-4.278 6.86.5.29 4.332-7.14 1.914-.008-4.314 7.32 1.8 1.035.215.125a.412.412 0 0 0 .29 0l4.76-2.759-.91.528-2.523-4.068Zm.375 5.315-1.819-2.852 1.109-1.882 2.387 3.757-1.677.977Z",
    fill: "#2D374B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m28.11 25.005 1.818 2.853 1.679-.973-2.386-3.761-1.111 1.881ZM33.134 25.737v-.78l-2.608-4.06-.967 1.64 2.517 4.071.91-.528a.4.4 0 0 0 .149-.294l-.001-.049Z",
    fill: "#28A0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m22.207 26.473 1.285.74 4.277-6.859-.726-.019a1.781 1.781 0 0 0-1.59.651l-2.429 3.765-.817 1.25v.472ZM30.239 20.354l-1.914.008-4.329 7.143 1.512.875.411-.7 4.32-7.326Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.935 20.343a1.219 1.219 0 0 0-.572-.98l-4.75-2.735a1.239 1.239 0 0 0-1.091 0c-.04.02-4.625 2.68-4.625 2.68a1.217 1.217 0 0 0-.689 1.032v5.665l.818-1.25-.009-4.37a.384.384 0 0 1 0-.048.4.4 0 0 1 .162-.256c.021-.015 4.685-2.715 4.7-2.722a.415.415 0 0 1 .359 0l4.695 2.7a.4.4 0 0 1 .186.321v5.405a.4.4 0 0 1-.14.294l-.91.527-.47.273-1.679.973-1.7.986a.411.411 0 0 1-.29 0l-2.015-1.153-.411.7 1.81 1.042.157.09.125.07a1.207 1.207 0 0 0 .924.016l4.955-2.867a1.208 1.208 0 0 0 .466-.91v-5.483h-.006Z",
    fill: "#96BEDC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 18,
    y1: 0,
    x2: 7.492,
    y2: 28.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03D1CF",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E09F8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmx);
export default __webpack_public_path__ + "static/media/gmx.d7115a71481bfa758f33d27f70772376.svg";
export { ForwardRef as ReactComponent };